import { useState } from "react";
import {
  TableCell,
  TableRow,
  Collapse,
  Table,
  TableBody,
} from "@material-ui/core";

import {
  requestStatusColors,
  convertMinutesToHours,
} from "@utils/commonFunctions";

function Row(props) {
  const [open, setOpen] = useState(false);
  const { row, unique, getTab } = props;

  return (
    <>
      <TableRow onClick={() => setOpen(!open)} key={unique}>
        <TableCell className="jobId-cell">{row.id || "-"}</TableCell>
        <TableCell className="jobType">{row.jobTypes?.name || "-"}</TableCell>
        {getTab === 0 && (
          <TableCell className="reportType">
            {row.cargoTypes?.name || "-"}
          </TableCell>
        )}
        <TableCell className="airBill">-</TableCell>
        <TableCell className="customer">
          {row.childCustomers?.name || "-"}
        </TableCell>
        <TableCell className="pieces">{row.quantity || "-"}</TableCell>
        <TableCell className="weight">{row.weight || "-"}</TableCell>
        <TableCell className="cto">{row.ctos?.name || "-"}</TableCell>
        <TableCell
          className={
            row.onlineRequestStatuses &&
            row.onlineRequestStatuses?.name &&
            `request-status ${requestStatusColors(
              row.onlineRequestStatuses && row.onlineRequestStatuses?.name
            )}`
          }
        >
          <span>{row.onlineRequestStatuses?.name || "-"}</span>
        </TableCell>
        <TableCell className="jobStatus">
          {row.jobStatuses
            ? row.jobStatuses.name === "Review Completed"
              ? "Completed"
              : row.jobStatuses.name === "Change Driver"
              ? "In Transit"
              : row.jobStatuses.name
            : "-"}
        </TableCell>
        <TableCell className="refNo">{row.referenceNo || "-"}</TableCell>
        <TableCell className="jobDuration">
          {row.totalDuration ? convertMinutesToHours(row.totalDuration) : "-"}
        </TableCell>
        <TableCell className="truckRego">{row.trucks?.rego || "-"}</TableCell>
      </TableRow>
      <TableRow className="sub-row">
        <TableCell
          className="MuiTableSubRoW"
          colSpan={props.getTab === 0 ? 13 : 14}
        >
          <Collapse in={open}>
            <Table stickyHeader aria-label="simple table">
              {row?.airWaybills?.map((item, index) => {
                return (
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell className="jobId-cell"></TableCell>
                      <TableCell className="jobType"></TableCell>
                      {props.getTab === 0 && (
                        <TableCell className="reportType"></TableCell>
                      )}
                      <TableCell className="airBill">
                        {" "}
                        {item.number || "-"}
                      </TableCell>
                      <TableCell className="customer">-</TableCell>
                      <TableCell className="pieces">
                        {item.quantity || "-"}
                      </TableCell>
                      <TableCell className="weight">
                        {item.weight || "-"}
                      </TableCell>
                      <TableCell className="cto"></TableCell>
                      <TableCell className="request-status"></TableCell>
                      <TableCell className="jobStatus"></TableCell>
                      <TableCell className="refNo"></TableCell>
                      <TableCell className="jobDuration"></TableCell>
                      <TableCell className="truckRego"></TableCell>
                    </TableRow>
                  </TableBody>
                );
              })}
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
